import { AdditionalStatus } from "../enums";

export class InsuranceViewModel {
  companyId: number;
  compulsory: number;
  voluntary: number;
  finalPremium: InsurancePriceView;
  basePremium: InsurancePriceView;
  discounts: InsurancePriceView;
  loads: InsurancePriceView;
  decline: InsuranceSpecificView;
  refer: InsuranceSpecificView;
  features: Features[];
  additions: Additions;
  rating: number;
  companyName: string;

  _showMoreInfo: boolean;

  constructor(values: any) {
    Object.assign(this, values);
    this.finalPremium = new InsurancePriceView(values ? values.finalPremium : {});
    this.basePremium = new InsurancePriceView(values ? values.basePremium : {});
    this.discounts = new InsurancePriceView(values ? values.discounts : {});
    this.loads = new InsurancePriceView(values ? values.loads : {});
    this.decline = new InsuranceSpecificView(values ? values.decline : {});
    this.refer = new InsuranceSpecificView(values ? values.refer : {});
    if (values.additions) {
      for (let addition of Object.keys(this.additions)) {
        this.additions[addition] = new InsuranceAdditionalView(values.additions[addition] ? values.additions[addition] : {});
      }
    }
    this._showMoreInfo = false;
  }

}

export class Additions {
  [key: number]: InsuranceAdditionalView;
}

class InsurancePriceView {
  amount: number;

  constructor(values: any) {
    Object.assign(this, values)
  }

}

export class Features {
  text: string;
  description: string;

  constructor(values: any) {
    Object.assign(this, values)
  }

}

class InsuranceSpecificView {
  isSpecific: true;

  constructor(values: any) {
    Object.assign(this, values)
  }
}

class InsuranceAdditionalView {
  additionalId: number;
  amount: number;
  status: AdditionalStatus;
  description: string[];
  inputMinimum: number;
  companyId: number;
  constructor(values: any) {
    Object.assign(this, values);
  }
}
